import classNames from 'classnames';
import { useState } from 'react';
import './TabsVerticalPanel.css';

export interface VerticalTab<T> {
  id: number;
  name: string;
  data?: T;
}

interface Props<T> {
  items: VerticalTab<T>[];
  children?: React.ReactNode;
  className?: string;
  selected?: VerticalTab<T>;
  onChange?: (item: VerticalTab<T>) => void;
}

export const TabsVerticalPanel = <T,>({
  children,
  className,
  items,
  selected,
  onChange,
}: Props<T>) => {
  const [selectedLast, setSelectedLast] = useState<VerticalTab<T>>(items[0]);

  const handleChange = (item: VerticalTab<T>) => {
    setSelectedLast(item);
    onChange?.(item);
  };

  //to be able to use as internal state and external "selected" property
  const selectedItem = selected ?? selectedLast;

  return (
    <div className="tabs-vertical-panel">
      <div className="tabs-vertical-panel__list">
        {items.map((item) => (
          <button
            key={item.id}
            className={classNames('tabs-vertical-panel__button', {
              'tabs-vertical-panel__button--active': selectedItem === item,
            })}
            onClick={() => handleChange(item)}
          >
            {item.name}
          </button>
        ))}
        {/* workaround to show borders */}
        <div className="tabs-vertical-panel__buttons-border" />
      </div>

      <div className={classNames('tabs-vertical-panel__content', className)}>
        {children}
      </div>
    </div>
  );
};
